import axios from 'axios';
import { CONSUMER_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const postStoreCustomerIdConfig = (brandId, data) => {
  return axios({
    method: "post",
    url:
      CONSUMER_BASE_URL +
      "/api/secure/v1/brand/" +
      brandId +
      "/store-customer-id-config", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreCustomerIdConfig = (brandId, storeCustomerId) => {
  return axios({
    method: 'get',
    url: CONSUMER_BASE_URL + "/api/secure/v1/brand/" + brandId + "/store-customer-id-config/" + storeCustomerId,
    headers: getHeaders(),
  });
};